import React from "react";
import "../../../assets/css/buttons/newButton.css";
import LegacyButton from "../../Atomos/Buttons/LegacyButton";
import ChevronRightTicker from "../../../assets/images&icons/chevron-right-ticker.svg";
interface BannerProps {
  title: string;
  description: string;
  header?: string;
  footer?: string;
  buttonText?: string;
  buttonClick?: () => void;
  backgroundImage: string;
}

const Banner: React.FC<BannerProps> = ({
  title,
  description,
  buttonText,
  buttonClick,
  backgroundImage,
  header,
  footer,
}) => {
  return (
    <div className="relative col-span-2 flex w-screen text-white -ml-16 -mr-8 md:-ml-28 md:-mr-8">
      <div
        className="absolute w-full h-full bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.50) 0%, rgba(0, 0, 0, 0.50) 100%), url(${backgroundImage})`,
        }}
      />
      <div className="flex w-full gap-4 p-10 items-center ml-8 md:ml-16">
        <div className="relative flex flex-col text-start z-10 w-full">
          <div className="text-md">{header}</div>
          <div className="flex flex-col gap-2">
            <div className="text-[32px] font-medium font-decimal">{title}</div>
            <div className="font-light text-[20px] font-decimal">
              {description}
            </div>
            <div className="text-lg italic">{footer}</div>
          </div>
        </div>
        {buttonText && (
          <LegacyButton
            text={buttonText}
            onClick={buttonClick}
            color="accent"
            content="textIcon"
            icon={
              <img
                src={ChevronRightTicker}
                alt="chevron"
                className="w-14 h-14"
              />
            }
            className="w-[400px] !h-[100px] !py-[10px] !text-[20px] !text-left !justify-start [&_span]:!text-left [&_span]:!justify-start !my-3"
          />
        )}
      </div>
    </div>
  );
};

export default Banner;
